import { PersonContactDetailsItem } from '@aibees/elephant/feature/search-table-people/types';
import type { Dispatch, PropsWithChildren, SetStateAction } from 'react';
import type { JSX as EmotionJSX } from 'react/jsx-runtime';
import { PeopleContactDetailItem, RefNames } from '../types';

/** Slice: unlock/loading state. Use so components don't re-render when config or data changes. */
export interface ContactDetailsStateContextValue {
  loading: boolean;
  unlocked: boolean;
  failed: boolean;
  disabled: boolean;
  isPopoverType: boolean;
}

/** Slice: tab/config and refs. Use so components don't re-render when state or data changes. */
export interface ContactDetailsConfigContextValue {
  activeTab: number;
  setActiveTab: Dispatch<SetStateAction<number>>;
  refs: RefNames;
  handleTabClick: (index: number) => void;
  config: {
    component: EmotionJSX.Element;
    refName: string;
    active: boolean;
  }[];
  showFullItems: boolean;
  setShowFullItems: Dispatch<SetStateAction<boolean>>;
  showSeeMore: boolean;
  setShowSeeMore: Dispatch<SetStateAction<boolean>>;
}

/** Slice: items and enrich action. Use so components don't re-render when state or config changes. */
export interface ContactDetailsDataContextValue {
  handleEnrichContactDetails: ({
    updateMode,
    updateJobChangeMode,
  }: {
    updateMode?: boolean;
    updateJobChangeMode?: boolean;
  }) => void;
  sortedItemsWithContentCheck: PeopleContactDetailItem[];
  hasUpdates: boolean;
  availableItems: PersonContactDetailsItem[];
  unlockableItems: PersonContactDetailsItem[];
  hasJobChange: boolean;
}

export interface ContactDetailsContextData
  extends ContactDetailsStateContextValue,
    ContactDetailsConfigContextValue,
    ContactDetailsDataContextValue {}

export enum ParentFeature {
  PERSON_DETAILS_PAGE = 'PERSON_DETAILS_PAGE',
  PERSON_SIDEBAR_UPDATES = 'PERSON_SIDEBAR_UPDATES',
  QUICK_INFO_CONTACT_DETAILS_POPOVER = 'QUICK_INFO_CONTACT_DETAILS_POPOVER',
  PERSON_DETAILS_SIDEBAR = 'PERSON_DETAILS_SIDEBAR',
  PERSON_UPDATES_PAGE = 'PERSON_UPDATES_PAGE',
}

export interface ContactDetailsContextProps extends PropsWithChildren {
  value?: ContactDetailsContextData;
  parentFeature: ParentFeature;
}
